var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"1px"}},[_c('rcTable',{ref:"rcTable",staticClass:"clusDetailsTab2",attrs:{"tableAttr":_vm.tableAttr}},[_c('logModal',{ref:"logModal",attrs:{"slot":"tootipL"},slot:"tootipL"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }